module.exports = __webpack_public_path__ + "img/calendar-gear-hover.405e67cc.svg";